// extracted by mini-css-extract-plugin
export default {"login":"Login_login__VTSm5","telia-logo":"Login_telia-logo__eUpn0"};